module.exports = __webpack_public_path__ + "completed.cb201b5b.svg";